// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1838":"f22be3c4431c5c48","4148":"0d8f299dbe0e330d"}[chunkId] + ".css";
};